// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ISubscriptionSchema } from '../entities/SubscriptionSchema';

export interface IGetSubscriptionsResponseSchema {
  /** Системное название категории **/
  categoryName: string;
  frequenciesList?: object[];
  /** Текст-заглушка пустой выдачи **/
  searchText?: string;
  /** URL страницы поиска **/
  searchUrl?: string;
  /** Список подписок **/
  subscriptions?: ISubscriptionSchema[];
  /** Заголовок категории **/
  title: string;
  /** Количество подписок **/
  total?: number;
  /** Тип категории **/
  type: EType;
}
export enum EType {
  /** Удаление **/
  'Delete' = 'delete',
  /** Общие подписки **/
  'Plain' = 'plain',
  /** Переключение вкл/выкл **/
  'Toggle' = 'toggle',
}
